import React from 'react';
const ReactMarkdown = require('react-markdown');

class Navigator extends React.Component{

    ref = React.createRef();

    state = {
      height: 0
    }

    componentDidMount(){
      this.setState({
        height: this.ref.current.clientHeight
      })
    }

    render(){

        return (
            <div className="row navigator" ref={this.ref} style={{backgroundImage: "url("+this.props.fields.backgroundImage.fields.file.url+")"}}>
                <div className="navigator-overlay" style={{height:this.state.height}}></div>
                <div className="navigator-links">
                    {
                        this.props.fields.navigatorLinkNames.map((link, i) =>
                            <div className="navigator-link"
                                 onClick={() => document.getElementById("root").children[0].children[this.props.fields.navigatorLinkNumber[i]].scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                {link}
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}

export default Navigator;
